import { type ActionItem } from 'shared/ui'
import { type RowConversion } from 'entities/Analytics/model/Table/rowConversion'
import { type EntitiesStore } from 'entities/EntitiesExport'
import {
  copySnippet,
  deleteConversion,
  editConversion,
} from 'pages/analytics/pages/conversions/ui/ConversionActions/conversionActions'

export const getConversionActions = (
  row: RowConversion,
  entities: EntitiesStore,
  onSuccess?: () => void
): ActionItem[] => {
  return [
    {
      text: 'Edit',
      icon: 'edit',
      onAction: () => {
        editConversion(row, onSuccess || (() => {}))
      },
    },
    {
      text: 'Copy snippet',
      icon: 'copy',
      onAction: () => {
        copySnippet(entities)
      },
    },
    {
      text: 'Delete',
      icon: 'delete',
      onAction: () => {
        deleteConversion(row, onSuccess)
      },
    },
  ]
}
